import type { LatLng } from '@/types/structs'

/* Port of isPossitionValid (sic — custom_functions.dart:37).
 * NOTE the asymmetry with queryCurrentUserLocation (geolocation.ts): this
 * one rejects only when BOTH coords are 0 (AND); the query treats EITHER
 * being 0 as invalid (OR). Two different rules in the original — kept. */
export function isPossitionValid(p: LatLng | null | undefined): boolean {
  if (p == null) return false
  if (p.lat === 0 && p.lng === 0) return false
  return true
}
